// File size limits
export const MAX_FILE_SIZE = 50 * 1024 * 1024 // 50MB

// Allowed file types for attachments
export const ALLOWED_FILE_TYPES = [
  'image/jpeg',
  'image/jpg',
  'image/png',
  'image/gif',
  'image/webp',
  'image/svg+xml',
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'text/plain',
  'text/csv',
  'application/zip',
  'application/x-zip-compressed',
]

// Default accepted types for upload components
export const DEFAULT_ACCEPTED_TYPES = [
  'image/*',
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'text/plain',
  'text/csv',
  'application/zip',
]

// File input accept string for HTML
export const FILE_INPUT_ACCEPT =
  'image/*,application/pdf,.doc,.docx,.xls,.xlsx,.txt,.csv,.zip'

// Upload status messages
export const UPLOAD_MESSAGES = {
  UPLOADING: 'Uploading...',
  CONFIRMING: 'Confirming upload...',
  ERROR: 'Upload failed',
  SUCCESS: 'Upload completed',
  SIZE_EXCEEDED: 'File size must be less than 50MB',
  TYPE_NOT_ALLOWED: 'File type not allowed',
  ALREADY_EXISTS: 'File already added',
  UPLOAD_FAILED: 'Upload failed. Please try again.',
  DELETE_FAILED: 'Failed to delete attachment',
  DOWNLOAD_FAILED: 'Failed to download file',
  DELETE_CONFIRM: 'Are you sure you want to delete this attachment?',
} as const
